<template>
    <v-container class="pt-0">
        <loading :loading="loading"></loading>
        <v-row v-if="complete" justify="space-around mt-0 pt-0">
            <v-col
                class="mt-0 pt-0"
                :xl="defaultColXl"
                :ld="defaultColLd"
                :md="defaultColMd"
                :sm="defaultColSm"
                :xs="defaultColXs"
            >
                <v-sheet
                    color="blue lighten-5"
                >
                    <v-row justify="space-around" class="">
                        <v-col cols="11">
                            <div class="font-weight-bold subtitle-1 text-center">{{
                                $t('view.contract_form.confirm_identification_email.messages.top') }}
                            </div>
                            <div class="mt-4">
                                <div>
                                    {{ $t(
                                    'view.contract_form.confirm_identification_email.messages.top_detail.target_email',
                                    {email: email}
                                    ) }}
                                </div>
                                <div>
                                    {{ $t('view.contract_form.confirm_identification_email.messages.top_detail.email_setting') }}
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-col>
        </v-row>
        <v-row v-else-if="initialRendering" justify="space-around mt-0 pt-0">
            <v-col
                class="mt-0 pt-0"
                :xl="defaultColXl"
                :ld="defaultColLd"
                :md="defaultColMd"
                :sm="defaultColSm"
                :xs="defaultColXs"
            >
                <v-sheet
                    color="blue lighten-5"
                >
                <v-row justify="space-around mt-0 pt-0">
                    <v-col cols="10" >
                        <div class=" text-center">
                            <label class="font-weight-bold subtitle-1">{{
                                $t('しばらくお待ち下さい。') }}</label>
                        </div>
                    </v-col>
                </v-row>
                </v-sheet>
            </v-col>
        </v-row>
        <v-row v-else-if="!showPersonalConfirm() && !showCompanyConfirm()" justify="space-around mt-0 pt-0">
            <v-col
                class="mt-0 pt-0"
                :xl="defaultColXl"
                :ld="defaultColLd"
                :md="defaultColMd"
                :sm="defaultColSm"
                :xs="defaultColXs"
            >
                <v-sheet
                    color="blue lighten-5"
                >
                <v-row justify="space-around mt-0 pt-0">
                    <v-col cols="10" >
                        <div class=" text-center">
                            <label class="font-weight-bold subtitle-1">{{
                                $t('view.contract_form.complete_submit_comparing_data.messages.complete_alert_top') }}</label>
                        </div>
                        <div class="mt-4">
                            <div>
                                {{ $t('view.contract_form.complete_submit_comparing_data.messages.complete_alert_detail.target_email') }}
                            </div>
                            <div>
                                {{$t('view.contract_form.complete_submit_comparing_data.messages.complete_alert_detail.after_process')}}
                            </div>
                            <div>
                                {{$t('view.contract_form.complete_submit_comparing_data.messages.complete_alert_detail.email_setting')}}
                            </div>
                        </div>
                    </v-col>
                </v-row>
                </v-sheet>
            </v-col>
        </v-row>
        <v-row v-if="!complete && showPersonalConfirm()" justify="space-around">
            <v-col
                :xl="defaultColXl"
                :ld="defaultColLd"
                :md="defaultColMd"
                :sm="defaultColSm"
                :xs="defaultColXs"
            >
                <label class="font-weight-bold title">{{ $t('view.contract_form.confirm_identification.identification_title') }}</label>
                <v-divider></v-divider>
            </v-col>
        </v-row>
<!-- ご本人確認FieldStart-->
        <v-row v-if="!complete && showPersonalConfirm()" justify="space-around mt-0 pt-0">
            <v-col
                class="mt-0 pt-0"
                :xl="defaultColXl"
                :ld="defaultColLd"
                :md="defaultColMd"
                :sm="defaultColSm"
                :xs="defaultColXs"
            >
                <v-sheet
                    color="blue lighten-5"
                >
                    <v-row justify="space-around mt-0 pt-0">
                        <v-col
                            xl="9"
                            ld="10"
                            md="11"
                            sm="11"
                            xs="11"
                        >
                            <div
                                v-for="message in $t('view.contract_form.confirm_identification.messages.message_to_idetification')"
                                :key="`contract-form-check-email-messages-${message}`"
                            >{{ message }}
                            </div>
                        </v-col>
                    </v-row>
                </v-sheet> 
                <error-panel ref="errorPanel" :error="hasError"></error-panel>
                <validation-observer ref="inputObserver" v-slot="InputObserver">
                    <!-- Name Start-->
                    <v-row class="mt-3">
                        <v-col cols="12" sm="12" md="3" class="mb-0 mt-0 pt-1 pb-1">
                            <v-sheet
                                class="pt-3 pb-3 text-center"
                                color="grey lighten-3"
                            >
                                <label class="mb-0 font-weight-bold">{{ $t('お名前')
                                    }}</label>
                            </v-sheet>
                        </v-col>
                        <v-col cols="12" sm="12" md="9" class="mb-0 mt-0 pt-1 pb-1">
                            <v-row>
                            <v-col cols="4" class="mb-0 mt-0 pt-2 pb-0">
                            <ValidationProvider vid="lastName" rules="required" v-slot="checked">
                                <v-text-field
                                    class="mt-0 pt-0 pb-0"
                                    :disabled="true"
                                    :label="$t('view.contract_form.update.label.office_info.request_person_last_name')"
                                    :hint="$t('view.contract_form.update.hint.office_info.request_person_last_name')"
                                    :placeholder="$t('view.contract_form.update.placeholder.office_info.request_person_last_name')"
                                    v-model="lastName"
                                    :persistent-hint="true"
                                    autocomplete="off"
                                ></v-text-field>
                            </ValidationProvider>
                            </v-col>
                            <v-col cols="4" class="ml-3 mb-0 mt-0 pt-2 pb-0">
                            <ValidationProvider vid="firstName" rules="required" v-slot="checked">
                                <v-text-field
                                    class="mt-0 pt-0 pb-0"
                                    :disabled="true"
                                    :label="$t('view.contract_form.update.label.office_info.request_person_first_name')"
                                    :hint="$t('view.contract_form.update.hint.office_info.request_person_first_name')"
                                    :placeholder="$t('view.contract_form.update.placeholder.office_info.request_person_first_name')"
                                    :persistent-hint="true"
                                    v-model="firstName"
                                    autocomplete="off"
                                ></v-text-field>
                            </ValidationProvider>
                            </v-col>
                        </v-row>
                        </v-col>
                    </v-row>
                    <v-row v-if="isPersonOnly()" class="pb-0 mb-0" justify="space-around">
                        <v-col cols="12" sm="12" class="mb-0 mt-0 pt-0 pb-0 text-center">
                            <a
                                target="_blank"
                                :href="$t('view.link.rehab_cloud_policy.href')"
                            >{{ $t('view.link.rehab_cloud_policy.text') }}</a>
                            ・
                            <a
                                target="_blank"
                                :href="$t('view.link.rehab_cloud_tablet_policy.href')"
                            >{{ $t('view.link.rehab_cloud_tablet_policy.text') }}</a>
                            ・
                            <a
                                target="_blank"
                                :href="$t('view.link.privacy.href')"
                            >{{ $t('view.link.privacy.text') }}</a>

                            <a target="_blank"
                                :href="$t('view.link.service_usage_compliance_document.href')"
                            >{{ $t('view.link.service_usage_compliance_document.text') }}</a><br>
                        </v-col>
                    </v-row>
                    <v-row justify="space-around">
                        <v-col cols="12" sm="6" md="6" class="mb-0 mt-0 pt-0 pb-1 text-center">
                            <v-btn
                                depressed
                                class="opener"
                                block
                                type="submit"
                                color="#00BE7E"
                                :dark="true"
                                >{{$t('view.contract_form.confirm_identification.subimit_person_button_caption.submit_comparing_data') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </validation-observer>
            </v-col>
        </v-row>
    <!-- ご本人確認FieldEnd -->
    <!-- 法人確認確認Start -->
    <v-row v-if="!complete && showCompanyConfirm()" justify="space-around">
            <v-col
                :xl="defaultColXl"
                :ld="defaultColLd"
                :md="defaultColMd"
                :sm="defaultColSm"
                :xs="defaultColXs"
            >
                <label class="font-weight-bold title">{{ $t('view.contract_form.confirm_identification.company_idetification_title') }}</label>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row v-if="!complete && showCompanyConfirm()" justify="space-around mt-0 pt-0">
            <v-col
                class="mt-0 pt-0"
                :xl="defaultColXl"
                :ld="defaultColLd"
                :md="defaultColMd"
                :sm="defaultColSm"
                :xs="defaultColXs"
            >
            <v-sheet
                    color="blue lighten-5"
                >
                    <v-row justify="space-around mt-0 pt-0">
                        <v-col
                            xl="9"
                            ld="10"
                            md="11"
                            sm="11"
                            xs="11"
                        >
                            <div
                                v-for="message in $t('view.contract_form.confirm_identification.messages.message_to_corporate_idetification')"
                                :key="`contract-form-check-email-messages-${message}`"
                            >{{ message }}
                            </div>
                        </v-col>
                    </v-row>
                </v-sheet> 
        <error-panel ref="errorPanel" :error="hasError"></error-panel>
        <validation-observer ref="inputObserver" v-slot="InputObserver">
                <v-row class="mt-3">
                        <v-col cols="12" sm="12" md="3" class="mb-0 mt-0 pt-0 pb-0">
                            <v-sheet
                                class="pt-3 pb-3 text-center"
                                color="grey lighten-3"
                            >
                                <label class="mb-0 font-weight-bold">
                                    {{ $t('view.contract_form.update.label.office_info.company_no') }}
                                </label>
                            </v-sheet>
                        </v-col>
                        <v-col cols="12" sm="12" md="3" class="mb-0 mt-0 pt-4 pb-0">
                            <ValidationProvider vid="companyNumber" rules="companyNumber|required" v-slot="checked">
                                <v-text-field
                                    class="mt-0 pt-0 pb-0"
                                    maxlength="13"
                                    counter="13"
                                    :disabled="true"
                                    :placeholder="$t('view.contract_form.update.placeholder.office_info.company_no')"
                                    :persistent-hint="true"
                                    v-model="companyNumber"
                                    autocomplete="off"
                                ></v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row class="mt-3">
                        <v-col cols="12" sm="12" md="3" class="mb-0 mt-0 pt-1 pb-1">
                            <v-sheet
                                class="pt-3 pb-3 text-center"
                                color="grey lighten-3"
                            >
                                <label class="mb-0 font-weight-bold">
                                    {{ $t('view.contract_form.update.label.office_info.company_name') }}
                                </label>
                            </v-sheet>
                        </v-col>
                        <v-col cols="12" sm="12" md="5" class="mb-0 mt-0 pt-1 pb-1">
                            <ValidationProvider vid="companyName" rules="required" v-slot="checked">
                                <v-text-field
                                    class="mt-0 pt-0 pb-0"
                                    :disabled="true"
                                    :hint="$t('view.contract_form.update.hint.office_info.company_name')"
                                    :placeholder="$t('view.contract_form.update.placeholder.office_info.company_name')"
                                    :persistent-hint="true"
                                    id="office_info_company_name"
                                    v-model="companyName"
                                    autocomplete="off"
                                ></v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                <v-row class="mt-3">
                <v-col cols="12" sm="12" md="3" class="mb-2 mt-0 pt-1 pb-1">
                    <v-sheet
                        class="pt-3 pb-3 text-center"
                        color="grey lighten-3"
                    >
                        <label class="mb-0 font-weight-bold">
                            {{ $t('法人住所') }}
                        </label>

                    </v-sheet>
                </v-col>
                <v-col cols="12" sm="12" md="6" class="mb-2 mt-0 pt-2 pb-0">
                    <v-row>
                        <v-col cols="4" class="mb-0 mt-0 pt-2 pb-0">
                            <ValidationProvider vid="zip1" rules="required|zip1" v-slot="checked">
                                <v-text-field
                                    class="mt-0 pt-0 pb-0"
                                    :disabled="true"
                                    :label="$t('view.contract_form.update.label.office_info.corporate_zip')"
                                    :hint="$t('view.contract_form.update.hint.office_info.corporate_zip_1')"
                                    :placeholder="$t('view.contract_form.update.placeholder.office_info.corporate_zip_1')"
                                    :persistent-hint="true"
                                    v-model="zip1"
                                    autocomplete="off"
                                ></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="1" class="mb-0 mt-0 pt-2 pb-0">
                            <label>-</label>
                        </v-col>
                        <v-col cols="4" class="mb-0 mt-0 pt-2 pb-0">
                            <ValidationProvider vid="zip2" rules="required|zip2" v-slot="checked">
                                <v-text-field
                                    class="mt-0 pt-0 pb-0"
                                    :disabled="true"
                                    :label="$t('view.contract_form.update.label.office_info.corporate_zip_2')"
                                    :hint="$t('view.contract_form.update.hint.office_info.corporate_zip_2')"
                                    :placeholder="$t('view.contract_form.update.placeholder.office_info.corporate_zip_2')"
                                    :persistent-hint="true"
                                    v-model="zip2"
                                    autocomplete="off"
                                ></v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col class="mb-0 mt-0 pt-2 pb-0" cols="12">
                            <ValidationProvider vid="address1" rules="required" v-slot="checked">
                                <v-text-field
                                    class="mt-0 pt-0 pb-0"
                                    :disabled="true"
                                    :label="$t('view.contract_form.update.label.office_info.corporate_address_1')"
                                    :placeholder="$t('都道府県')"
                                    v-model="address1"
                                >
                                </v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col class="mb-0 mt-0 pt-2 pb-0" cols="12">
                            <ValidationProvider vid="address2" rules="required" v-slot="checked">
                                <v-text-field
                                    class="mt-0 pt-0 pb-0"
                                    :disabled="true"
                                    :label="$t('view.contract_form.update.label.office_info.corporate_address_2')"
                                    :hint="$t('view.contract_form.update.hint.office_info.corporate_address_2')"
                                    :placeholder="$t('view.contract_form.update.placeholder.office_info.corporate_address_2')"
                                    :persistent-hint="true"
                                    v-model="address2"
                                    autocomplete="off"
                                ></v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col class="mb-0 mt-0 pt-2 pb-0" cols="12">
                            <ValidationProvider vid="address3" rules="required" v-slot="checked">
                                <v-text-field
                                    class="mt-0 pt-0 pb-0"
                                    :disabled="true"
                                    :label="$t('view.contract_form.update.label.office_info.corporate_address_3')"
                                    :hint="$t('view.contract_form.update.hint.office_info.corporate_address_3')"
                                    :placeholder="$t('view.contract_form.update.placeholder.office_info.corporate_address_3')"
                                    :persistent-hint="true"
                                    v-model="address3"
                                    autocomplete="off"
                                ></v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row class="pb-0 mb-0" justify="space-around">
                        <v-col cols="12" sm="12" class="mb-0 mt-0 pt-0 pb-0 text-center">
                            <a
                                target="_blank"
                                :href="$t('view.link.rehab_cloud_policy.href')"
                            >{{ $t('view.link.rehab_cloud_policy.text') }}</a>
                            ・
                            <a
                                target="_blank"
                                :href="$t('view.link.rehab_cloud_tablet_policy.href')"
                            >{{ $t('view.link.rehab_cloud_tablet_policy.text') }}</a>
                            ・
                            <a
                                target="_blank"
                                :href="$t('view.link.privacy.href')"
                            >{{ $t('view.link.privacy.text') }}</a>
                            
                            <a target="_blank"
                                :href="$t('view.link.service_usage_compliance_document.href')"
                            >{{ $t('view.link.service_usage_compliance_document.text') }}</a>
                            <br>
                        </v-col>
            </v-row>
            <v-row justify="space-around">
                        <v-col cols="12" sm="6" md="6" class="mb-0 mt-0 pt-0 pb-1 text-center">
                            <v-btn
                                depressed
                                class="login-button"
                                block
                                type="submit"
                                color="#11479B"
                                :dark="true"
                                :readonly="true"
                                :active="false"
                                @click="submitCorporateData"
                            >
                            <div v-if="isCompanyOnly()">
                                {{$t('view.contract_form.confirm_identification.subimit_company_button_caption.submit_only_comparing_data') }}
                            </div>
                            <div v-else>
                                {{$t('view.contract_form.confirm_identification.subimit_company_button_caption.submit_comparing_data') }}
                            </div>
                            </v-btn>
                        </v-col>
            </v-row>
        </validation-observer>
    </v-col>
    <simple-dialog
            :show-dialog="showAlertDialog"
            :default-msg="alertDialogMessage"
            :is-confirm="false"
            :is-html='true'
            @ok-click="dialogClose()"
            @cancel-click="dialogClose()"
        ></simple-dialog>
    </v-row>
    </v-container>
</template>
<script type="text/javascript">
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import axios from 'axios';
    import ErrorPanel from "../../components/globals/ErrorPanel";
    import Loading from "../../components/globals/Loading";
    import DatePickerWrapper from "../../components/datepicker/DatePickerWrapper";
    import SimpleDialog from "../../components/globals/SimpleDialog";
    const UPLOADER_SUBMISSION_STATUS = {
        INCOMPLETE: 0,
        CANCEL: 1,
        SUBMIT: 2,
        COMPLETE: 3
    };
    const EKYC_STATUS = {
        APPROVED: 1,
        DENIED: 2,
        IN_PROGRESS: 3,
        SENT_MAIL: 4
    };
    const POST_TYPE = {
        COMPANY_ONLY: "company",
        PERSONAL_ONLY: "personal",
        BOTH_OF_THEM: "both"
    };
    @Component({
        components: {Loading, ErrorPanel, DatePickerWrapper, SimpleDialog}
    })
    export default class Identification extends Vue {
        data() {
            return {
                defaultColXl: 9,
                defaultColLd: 9,
                defaultColMd: 9,
                defaultColSm: 11,
                defaultColXs: 11,
                firstName: "",
                lastName: "",
                email: "",
                zip1: "",
                zip2: "",
                address1: "",
                address2: "",
                address3: "",
                companyNumber: "",
                companyName: "",
                personalStatus: 0,
                companyStatus: 0,
                uploaderStatus: 0,
                hasError: false,
                complete: false,
                loading: false,
                isWrongCompanyNumber: false,
                initialRendering: true,
                postType: "",
                alertDialogMessage: '',
                showAlertDialog: false,
                trustDock: null
            };
        }

        refs() {
            return this.$refs;
        }

        dialogClose() {
            this.showAlertDialog = false;
        }
        
        async mounted() {
            this.$emit('title-change', this.$t('view.contract_form.confirm_identification.top_title'));
            this.loading = true;
            if (!this.$route.params.applicationId) {
                this.loading = false;
                this.$router.push({path: '/'});
            }
            let self_ = this;
            let url_ = this.$invokeUrlMaker.create(`ekyc/get/${this.$route.params.applicationId}`);
            await axios.get(url_).then(function (res) {
                if (!res || res.data.ekycInfoData.expireUrlFlg || res.data.ekycInfoData.denialUrlFlg) {
                    self_.$router.push({path: '/'});
                }
                self_.setInitialData(res.data.ekycInfoData);
                self_.decidePostType();
                self_.loading = false;
            }).catch(function (e) {
                self_.$router.push({path: '/'});
                self_.loading = false;
            });
            this.initialRendering = false;
            this.loading = false;
        }
        
        setInitialData(data) {
                this.firstName = data.firstName;
                this.lastName = data.lastName;
                this.email = data.officeInfoRequestEmail;
                this.zip1 = data.companyZip1;
                this.zip2 = data.companyZip2;
                this.address1 = data.companyAddress1;
                this.address2 = data.companyAddress2;
                this.address3 = data.companyAddress3;
                this.companyName = data.companyName;
                this.personalStatus = data.personalStatus; 
                this.companyStatus = data.companyStatus;
                let personalPublicId = data.ekycPersonalPublicId;
                this.torihikisakiId = data.torihikisakiId;
                this.companyNumber = data.companyNumber;
                this.uploaderStatus = data.uploaderStatus;
                // Uploader Initialize
                this.trustDock = new Trustdock({
                publicId: personalPublicId,
                plans: [
                    {
                        id: `${this.$customEnv.get('PERSONAL_PLAN_ID')}`
                    },
                    {
                        id: `${this.$customEnv.get('SELFIE_PLAN_ID')}`,
                        document_source_plan_id: `${this.$customEnv.get('PERSONAL_PLAN_ID')}`
                    }
                    ],
                openerSelector: '.opener'
            });
        }

        decidePostType() {
            if ((this.personalStatus === EKYC_STATUS.DENIED || this.personalStatus === EKYC_STATUS.SENT_MAIL) &&
                (this.companyStatus === EKYC_STATUS.DENIED || this.companyStatus === EKYC_STATUS.SENT_MAIL)) {
                 this.postType = POST_TYPE.BOTH_OF_THEM;
            }
            if ((this.personalStatus === EKYC_STATUS.IN_PROGRESS || this.personalStatus === EKYC_STATUS.APPROVED) &&
                (this.companyStatus === EKYC_STATUS.DENIED || this.companyStatus === EKYC_STATUS.SENT_MAIL)) {
                 this.postType = POST_TYPE.COMPANY_ONLY;
            }
            if ((this.personalStatus === EKYC_STATUS.DENIED || this.personalStatus === EKYC_STATUS.SENT_MAIL) &&
                (this.companyStatus === EKYC_STATUS.IN_PROGRESS || this.companyStatus === EKYC_STATUS.APPROVED)) {
                 this.postType = POST_TYPE.PERSONAL_ONLY;
            }
        }

        showPersonalConfirm() {
            if (this.personalStatus === EKYC_STATUS.DENIED ||
                this.personalStatus === EKYC_STATUS.SENT_MAIL) {
                return true;
            } 
            return false;
        };

        showCompanyConfirm() {
            if (this.companyStatus === EKYC_STATUS.DENIED ||
                this.companyStatus === EKYC_STATUS.SENT_MAIL) {
                return true;
            } 
            return false;
        };

        isCompanyOnly() {
            if (this.postType === POST_TYPE.COMPANY_ONLY) {
                return true;
            }
            return false;
        }

        isPersonOnly() {
            if (this.postType === POST_TYPE.PERSONAL_ONLY) {
                return true;
            }
            return false;
        }

        @Watch('trustDock')
        trustDockStatus() {
            this.trustDock.on('documentsubmitted', this.documentsubmittedAction);
            this.trustDock.on('completed', this.completedAction);
            this.trustDock.on('canceled', this.canceledAction);
        }

       async documentsubmittedAction() {
            if (this.uploaderStatus === UPLOADER_SUBMISSION_STATUS.INCOMPLETE ||
                this.uploaderStatus === UPLOADER_SUBMISSION_STATUS.CANCEL) {
                this.uploaderStatus = UPLOADER_SUBMISSION_STATUS.SUBMIT;
                let self_ = this;
                self_.loading = true;
                let url_ = self_.$invokeUrlMaker.create(`ekyc/update_uploader_status`);
                let params = JSON.stringify({
                    applicationId: self_.$route.params.applicationId,
                    uploaderStatus: self_.uploaderStatus
                });
                await axios.post(
                    url_,
                    params
                ).then(
                    function (res) {
                        self_.loading = false;
                    }
                ).catch(
                    function (err) {
                        self_.loading = false;
                        console.log(err);
                    }
                );
            }
            await this.submitPersonalData();
        }

        async completedAction() {
            if (this.uploaderStatus === UPLOADER_SUBMISSION_STATUS.INCOMPLETE ||
                this.uploaderStatus === UPLOADER_SUBMISSION_STATUS.CANCEL) {
                this.uploaderStatus = UPLOADER_SUBMISSION_STATUS.COMPLETE;
            }
        }

        canceledAction() {
            if (this.uploaderStatus === UPLOADER_SUBMISSION_STATUS.INCOMPLETE ||
                this.uploaderStatus === UPLOADER_SUBMISSION_STATUS.CANCEL) {
                    this.uploaderStatus = UPLOADER_SUBMISSION_STATUS.CANCEL;
                }
        }

        errorDialog(statusCode, message) {
            if (statusCode === 422) {
                this.isWrongCompanyNumber = true;
                this.alertDialogMessage = message;
                this.showAlertDialog = true;
            } else if (statusCode === 400) {
                this.alertDialogMessage = message;
                this.showAlertDialog = true;
            }
        }

        submitPersonalData() {
            let self_ = this;
            if (self_.postType === POST_TYPE.PERSONAL_ONLY) {
                self_.loading = true;
                let url_ = self_.$invokeUrlMaker.create(`ekyc/confirm`);
                let params = JSON.stringify({
                    postType: self_.postType,
                    applicationId: self_.$route.params.applicationId
                });
                axios.post(
                    url_,
                    params
                ).then(
                    function (res) {
                        self_.complete = true;
                        self_.loading = false;
                    }
                ).catch(
                    function (err) {
                        self_.loading = false;
                        console.log(err);
                    }
                );
            }
        }
        submitCorporateData() {
            if (this.uploaderStatus === UPLOADER_SUBMISSION_STATUS.CANCEL ||
                this.uploaderStatus === UPLOADER_SUBMISSION_STATUS.INCOMPLETE ||
                this.uploaderStatus === undefined) {
                this.alertDialogMessage = '公的身分証の確認／セルフィーを先に実施して下さい。';
                this.showAlertDialog = true;
                return;
            }
            if (this.isWrongCompanyNumber) {
                this.alertDialogMessage = '法人番号が誤っている可能性があります。詳細は営業担当までお問い合わせください。';
                this.showAlertDialog = true;
                return;
            }
            let self_ = this;
            self_.loading = true;
            let url_ = self_.$invokeUrlMaker.create(`ekyc/confirm`);
            let params = JSON.stringify({
                postType: self_.postType,
                applicationId: self_.$route.params.applicationId
            });
            axios.post(
                url_,
                params
            ).then(
                function (res) {
                    self_.complete = true;
                    self_.loading = false;
                }
            ).catch(
                function (err) {
                    self_.loading = false;
                    console.error(err);
                    if (err.response.status === undefined) {
                        console.error("unexpected server error.");
                        self_.errorDialog(err.response.status, "システムエラーが発生しました。詳細は営業担当までお問い合わせください。");
                    } else {
                        self_.errorDialog(err.response.status, err.response.data.customMessage);
                    } 
                }
            );
        };
    }
</script>



// WEBPACK FOOTER //
// src/pages/identification_form/IdentificationForm.vue